import { render } from "./ProductFormFields.vue?vue&type=template&id=2d72f869"
import script from "./ProductFormFields.vue?vue&type=script&lang=js"
export * from "./ProductFormFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__